module.exports = __webpack_public_path__ + "static/SecurityPageHeroImage-3ae23d5227d5a506e5305fad18336fef.png";